var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.46213 0C9.25778 0 9.04989 0.0843659 8.87693 0.272687L5.16435 4.31134H2.58218C1.15597 4.31134 0 5.64294 0 7.28574V9.92913C0 11.5717 1.15619 12.9035 2.58218 12.9035H5.16435L8.87693 16.9422C9.05011 17.1305 9.25845 17.2149 9.46213 17.2149C9.9051 17.2149 10.3287 16.8169 10.3287 16.2216V0.993239C10.3287 0.398003 9.9051 0 9.46213 0ZM5.16435 12.0427H2.58218C2.14566 12.0427 1.72805 11.8386 1.40617 11.4682C1.05424 11.0628 0.860798 10.5166 0.860798 9.92913V7.28574C0.860798 6.69852 1.05424 6.15181 1.40617 5.74667C1.72805 5.37626 2.14566 5.17214 2.58218 5.17214H5.16435V12.043V12.0427Z",
    fill: "#F87E03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9023 5.16423V6.02503C12.3283 6.02503 13.4845 7.18122 13.4845 8.60721C13.4845 10.0332 12.3283 11.1894 10.9023 11.1894V12.0502C12.804 12.0502 14.3453 10.5087 14.3453 8.60721C14.3453 6.70575 12.8038 5.16423 10.9023 5.16423ZM10.9023 3.44263V4.30342C13.2795 4.30342 15.2061 6.23004 15.2061 8.60698C15.2061 10.9841 13.2795 12.9108 10.9023 12.9108V13.7716C13.7548 13.7716 16.0667 11.4594 16.0667 8.60721C16.0667 5.75502 13.7548 3.44286 10.9023 3.44286V3.44263ZM10.9023 6.8856V10.3286C11.8533 10.3286 12.6239 9.55771 12.6239 8.60698C12.6239 7.65647 11.8535 6.8856 10.9023 6.8856Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.b7898802e9864e409b35354b772a1204.svg";
export { ForwardRef as ReactComponent };